import * as React from "react";
import { Navigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import useAuth from "../../hooks/useAuth";

// For routes that can only be accessed by authenticated users
function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuth();
  const location = useLocation();

  // List of public auth routes that don't require authentication
  const publicAuthRoutes = ["/auth/sign-in", "/auth/sign-up", "/auth/reset-password"];
  
  // Check if current path is a public auth route
  const isPublicAuthRoute = publicAuthRoutes.some(route => 
    location.pathname.startsWith(route)
  );

  // Only redirect to sign-in if:
  // 1. Initialization is complete
  // 2. User is NOT authenticated
  // 3. User is NOT already on a public auth route
  if (isInitialized && !isAuthenticated && !isPublicAuthRoute) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  return <React.Fragment>{children}</React.Fragment>;
}

export default AuthGuard;
